module.exports = __webpack_public_path__ + "static/media/IMG_0707.49f7c111.HEIC";